import { MenuItemLink, MenuItemLinkProps } from 'react-admin';

export const AppBarMenuItemLink = (props: MenuItemLinkProps) => (
  <MenuItemLink
    {...props}
    dense={false}
    state={{ _scrollToTop: true, ...(props.state || {}) }}
    tooltipProps={{ disableInteractive: true, children: <></>, title: '' }} // Disable tooltip
  />
);